import React from 'react';
import { Crown } from 'lucide-react';

const Logo = ({ variant = 'default', className = '' }) => {
  const isLight = variant === 'light';
  
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* Crown Icon */}
      <div className="relative">
        <Crown 
          size={36} 
          className="text-[#D4AF37]" 
          strokeWidth={2}
          fill="#D4AF37"
        />
      </div>
      
      {/* Text */}
      <div className="flex flex-col leading-none">
        <div className="flex items-baseline gap-1">
          <span className={`font-extrabold text-lg tracking-tight ${isLight ? 'text-white' : 'text-[#0a2342]'}`}>
            KING
          </span>
          <span className={`font-medium text-sm ${isLight ? 'text-white/80' : 'text-gray-600'}`}>
            of
          </span>
          <span className={`font-extrabold text-lg tracking-tight ${isLight ? 'text-white' : 'text-[#0a2342]'}`}>
            IT
          </span>
        </div>
        <span className={`text-[10px] tracking-[0.2em] uppercase font-medium ${isLight ? 'text-[#D4AF37]' : 'text-[#D4AF37]'}`}>
          IT Consulting
        </span>
      </div>
    </div>
  );
};

export default Logo;
